import React, { useState, useEffect, useRef } from 'react'
import { useQuickAdd } from '../../../hooks/useQuickAdd'
import { useCart } from '../../../hooks/useCart'
import Options from './Options'
import Price from '../../Price'
import useLangStrings from '../../../hooks/useLangStrings'
import QuantityAdjuster from './QuantityAdjuster'
import ReChargeForm from './ReChargeForm'
interface Props {
  dataSet: any;
}
/* eslint-disable camelcase */
type tRechargeVariantMap = Record<string, { discount_variant_id: number, discount_variant_price: string  }>
export interface iReChargeProduct {
  hasReCharge: boolean
  discount: number
  id: number
  isSubscriptionOnly: boolean,
  originalHandle: string | null,
  originalToHiddenVariantMap: tRechargeVariantMap
  shippingIntervalFrequency: string,
  shippingIntervalType: string,
  subscriptionId: number,
  strings: {
    oneTimePurchase: string
    subAndSave: string
    howItWorks: string
    deliveryEvery: string
    learnMore: string
    shopName: string
    shopDomain: string
  }
}

const QuickAdd: React.FunctionComponent<Props> = ({ dataSet }: Props) => {
  const {addToCart, addSubsProduct} = useCart()
  const { btn } = useRef(null) as any
  const { product, setHandle, setSelectedOptions,  selectedOptions, currentVariant, stockMap, swatch } = useQuickAdd()
  const { oosText, fullDetailsCta, atcText, pleaseSelectText, preOrderText, wholeBeanGrind, cafetiereGrind, filterGrind, espressoGrind } = useLangStrings(dataSet.langStrings);
  const [productQuantity, setProductQuantity] = useState(1);
  const [isReCharge, setIsReCharge] = useState<boolean>(false);
  const [reChargeData, setReChargeData] = useState<iReChargeProduct>(null);
  const [frequencySelected, setFrequencySelected] = useState('');
  const [isAuto, setIsAuto] = useState(false)
  const [sellingPlanId, setSellingPlanId] = useState(null as null|number);

  useEffect(() => {
    if (product) {
      const fetchRechargeJSON = async() => {
        const reChargeJson: iReChargeProduct = await fetch(`/products/${product.handle}?view=recharge_data`).then(res => res.json()).catch(e => console.info(e))
        if (Object.keys(reChargeJson).length) {
          setReChargeData(reChargeJson)
        }
        if (Object.keys(reChargeJson).length > 0) {
          setIsReCharge(true)
        } else  {
          setIsReCharge(false)
        }
      }
      fetchRechargeJSON()
      if (window['ReloadSmartWishlist']) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.ReloadSmartWishlist()
      }
    }
  }, [product])

  if (!product) {
    return <></>
  }
 
  const styles = (): Record<string | null, string | null> => {
    return swatch ? swatch : {}
  }

  const preOrder = Boolean(currentVariant && stockMap[currentVariant.id] === 'pre-order')
  const close = () => {
    setHandle(null)
    setProductQuantity(1)
    setIsReCharge(false)
  }
  
  const optionsRemaining = product.options.filter((option, index) => option && !selectedOptions[index])

  const singleOptionRemaining = optionsRemaining.length === 1 ? optionsRemaining[0].name : ''

  const pleaseSelectTextReplaced = pleaseSelectText ? pleaseSelectText.replace('{{ option_name }}', singleOptionRemaining) : '';

  const actText = currentVariant ?
    currentVariant.available ? atcText : oosText : pleaseSelectTextReplaced
  return (
    <div className="quick-add-popup-wrap">
      <div className="quick-add-underlay" onClick={close}></div>

      <aside className="quick-add-popup relative" style={styles()}  data-productid={isReCharge ? product.id : ''}>
        <main className="quick-add-main"> 
          <div className="quick-add-info flex flex-column justify-center">
            <h3 className="quick-add-title heading-3-alt"> { product.title }</h3>
            <Price
              finalPrice={product.price}
              originalPrice={product.compare_at_price ? product.compare_at_price : product.price}
              priceVaries={Boolean(product.price_varies)}
              priceMin={product.min_price ? product.min_price : product.price}
            />
            <Options
              selectedOptions={selectedOptions}
              product={product}
              stockMap={stockMap}
              grindOptions={[wholeBeanGrind, cafetiereGrind, filterGrind, espressoGrind]}
              onChange={setSelectedOptions}>
            </Options>
            {isReCharge && <ReChargeForm product={product} setSellingPlanId={setSellingPlanId} reChargeData={reChargeData} currentVariant={currentVariant} setFrequencySelected={setFrequencySelected} setIsAuto={setIsAuto}/>}
            <div className="flex align-center gap-small margin-t-auto adjuster-btn-wrapper">
              <QuantityAdjuster update={setProductQuantity} amt={productQuantity} />
              <button
                className="quick-add-btn atc-wl-btn"
                type="button"
                ref={btn}
                disabled={!(currentVariant && currentVariant.available && productQuantity > 0)}
                onClick={() => {
                  if(isAuto && isReCharge && reChargeData) {
                    addSubsProduct(
                      btn?.current,
                      currentVariant.id,
                      productQuantity,
                      sellingPlanId,
                      {}
                    )
                  } else {
                    addToCart(
                      [
                        {
                          id: currentVariant.id,
                          quantity: productQuantity,
                          properties: isReCharge && isAuto ? {
                            shipping_interval_unit_type: reChargeData.shippingIntervalType,
                            shipping_interval_frequency: frequencySelected
                          } : {}
                        }],
                      true,
                      close)
                  }
                } 
                }
              >{preOrder ? preOrderText : actText}<span className="smartwishlist" data-product= {product.id} data-variant={product.variants[0].id}></span>
              </button>
            </div>
            
            <div className="quick-add-full-details-wrap">
              <a href={`/products/${product.handle}`}>{ fullDetailsCta }</a>
            </div>
          </div>
        </main>
        <span className="close_btn" onClick={close}></span>
      </aside>
    </div>
  )
  

};

export default QuickAdd